module.exports = __webpack_public_path__ + "img/star-1.36ef244a.svg";